import React, { useState } from "react";

// ASSETS
import XSign from "assets/svg/XSignModal.svg";
import Filter from "assets/svg/Filtre.svg";

// STYLES
import {
  MobileCalendarFilterContainer,
  ImageHamburger,
  Modal,
  ModalContentWrapper,
  ModalCloseButton,
  XImg,
  ModalContent,
  FiltersButton,
  FiltersWrapper,
  TitleWrapper,
} from "./MobileCalendarFiltersStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";

// MISC

import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps, Filters } from "./MobileCalendarFiltersModel";
import { CalendarType } from "components/Atoms/CalendarFilter/CalendarFilterModel";

// REDUX

// COMPONENTS
import SelectInputFilter from "components/Atoms/SelectInputFilter/SelectInputFilter";
import CalendarFilter from "components/Atoms/CalendarFilter/CalendarFilter";
import CustomText from "components/Atoms/CustomText/CustomText";
import { CheckProps } from "components/Atoms/SelectInputFilter/SelectInputFilterModel";

const MobileHeaderAtom = (props: IProps) => {
  // PROPERTIES
  const {
    type = Filters.past,
    month,
    year,
    setMonth,
    setYear,
    checkedState,
    setCheckedState,
  } = props;

  // STATE CONSTANTS
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <MobileCalendarFilterContainer onClick={openModal}>
        <ImageHamburger src={Filter} />
      </MobileCalendarFilterContainer>
      {isModalOpen && (
        <Modal>
          <ModalContentWrapper>
            <ModalCloseButton onClick={closeModal}>
              <XImg src={XSign} alt="close" />
            </ModalCloseButton>
            <ModalContent>
              <FiltersWrapper>
                <TitleWrapper>
                  <CustomText
                    type={TextType.H5bold}
                    text={t("view.newsAndMedia.events.filters.eventFilters")}
                    color={COLORS.Cultured}
                  />
                </TitleWrapper>

                <SelectInputFilter
                  checkedState={checkedState}
                  setCheckedState={setCheckedState}
                />
                <CalendarFilter
                  type={CalendarType.month}
                  month={month}
                  year={year}
                  setMonth={setMonth}
                  setYear={setYear}
                />
                {type === Filters.past && (
                  <CalendarFilter
                    type={CalendarType.year}
                    month={month}
                    year={year}
                    setMonth={setMonth}
                    setYear={setYear}
                  />
                )}
              </FiltersWrapper>
              <FiltersButton onClick={closeModal}>
                <CustomText
                  type={TextType.H5}
                  text={t("view.newsAndMedia.events.filters.applyFilters")}
                  color={COLORS.Cultured}
                />
              </FiltersButton>
            </ModalContent>
          </ModalContentWrapper>
        </Modal>
      )}
    </>
  );
};

export default MobileHeaderAtom;
